import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { getLayout as a } from "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
async function T(i) {
  const s = a().isQuebecFrench, o = "?dialog=true&slate=true&fluid=true", m = s ? `${o}&lang=fr` : o, p = await (await fetch(i + m)).text(), t = new DOMParser().parseFromString(p, "text/html"), e = t.body.getElementsByClassName("policyButtons");
  for (; e.length > 0; )
    e[0].parentNode?.removeChild(e[0]);
  let r = t.body.innerHTML;
  const n = t.body.querySelector("div[id^='contentTopInner']");
  return n !== null && (r = n.innerHTML), r;
}
export {
  T as htmlContentOnly
};
//# sourceMappingURL=index.js.map
